import { Theme } from '@mui/material';


const Link = (theme: Theme) => {
  return {
  };
};

export default Link;
